import React, { Component } from 'react';
import axios from 'axios';
//import { MDBContainer, MDBIframe } from "mdbreact";
import {
    MDBInput, MDBDatePicker, MDBSelect, toast, ToastContainer, MDBBtnFixedItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge,
    MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import AsyncSelect from 'react-select/async';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';

class Recruit extends Component {
    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            fname: "",
            lname: "",
            title: "",
            preferredName: "",
            initials: "",
            idNumber: "",
            telHome: "",
            telMobile: "",
            address1: "",
            address2: "",
            address3: "",
            DOB: "",
            postCode: "",
            provinceId: 0,
            townId: 0,
            provinces: [],
            towns: [],
            journeys: [],
            modalOpen: false,
            townModalOpen: false,
            btnDisabled: false,
            selectedTown: '',
            selectedProvince: '',
            townBtnHidden: false,
            emailAddress: '',
            sfJourneyId: 0,
            msg: ''
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleTownSelectChange = this.handleTownSelectChange.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.toggle = this.toggle.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.toggleTown = this.toggleTown.bind(this);
    }

    loadSuburbs = async (inputText, callback) => {
        let province = this.state.selectedProvince.toUpperCase();
        province = province.replace(/ /g, '');
        const response = await axios.get(`https://api.siteway.co.za/fastway/woo/v1/find-suburb-province-all/?query=${inputText}`);
        const json = response.data;
        let suburbs = [];
        json.forEach((item) => {
            //var str = item.value;
            //var res = str.split("(");
            //var provPart = res[1];
            //provPart = provPart.split("-");//[0].trim().toUpperCase();
            //var provincePart = "";

            //if (provPart.length > 1) {
            //    var count = provPart.length - 1;
            //    for (var i = 0; i < count; i++) {
            //        provincePart += provPart[i].toUpperCase();
            //    }
            //} else {
            //    provincePart = provPart[0].trim().toUpperCase();
            //}
            //provincePart = provincePart.replace(/ /g, '');
            //provincePart = provincePart.replace(/-/g, '');
            //if (provincePart == province) {
                suburbs.push(item);
            //}
        });
        callback(suburbs.map(item => ({ label: item.text, value: item.value })));
    }

    onSuburbChange = selSuburb => {
        this.setState({
            selectedTown: selSuburb.value,
            townModalOpen: !this.state.townModalOpen
        })

    }

    async disableButton() {
        this.setState({ btnDisabled: true });
        this.submitHandler();
    }

    toggleTown() {
        this.setState({
            townModalOpen: !this.state.townModalOpen
        });
    }

    toggle() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
        const { history } = this.props;
        history.push({
            pathname: '/salesforce/demonstratorlist/1'
            //search: 'unitId=' + unitId,
            //state: { detail: unitName }
        })
    }

    handleTownSelectChange(selected) {
        if (selected.length > 0) {
            this.setState({
                sfJourneyId: selected[0]
            });
        }
        
    }

    async handleSelectChange(selected) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/gettowns?provinceId=' + selected, 200);
        let selProvince = ''
        this.state.provinces.forEach(x => {
            if (x.value == selected) {
                selProvince = x.text.trim();
            }
        })
        this.setState({
            provinceId: selected[0],
            townId: result.data[0].value,
            towns: result.data,
            selectedProvince: selProvince,
            selectedTown: selected == 10 ? 'Outside South Africa' : '',
            townBtnHidden: selected == 10 ? true : false
        });
        this.props.loaderOff();
    }

    async submitHandler() {//submitHandler = event => {
        //event.preventDefault();
        let tetettete = this.state.sfJourneyId;
        let dd = new Date();
        let stateDate = new Date(this.state.DOB);
        let currDate = dd.getFullYear() + "" + dd.getMonth() + "" + dd.getDay()
        let selectedDate = stateDate.getFullYear() + "" + stateDate.getMonth() + "" + stateDate.getDay()
        let telMobile = '' + this.state.telMobile;
        telMobile = telMobile.trim();

        var idVal = this.state.idNumber;
        idVal = idVal.replace(/(^\s+|\s+$)/g, '');
        idVal = idVal.replace(/\s/g, "");
        var a, b, c, d, intCount
        var isId = false;
        if (idVal.substring(0, 2).toLowerCase() == 'pp') {
            isId = true;
        } else {
            var checkDigit = parseInt(idVal.charAt(idVal.length - 1));
            var odd = 0;
            var even = "";
            var evenResult = 0;
            var result;
            for (var c = 1; c <= idVal.length; c++) {
                if (c % 2 == 0) {
                    even += idVal.charAt(c - 1);
                } else {
                    if (c == idVal.length) {
                        continue;
                    } else {
                        odd = (parseInt(odd) + parseInt(idVal.charAt(c - 1)));
                    }
                }
            }
            even = (Number(even) * 2);
            even = even.toString();
            for (var r = 1; r <= even.length; r++) {
                evenResult = (parseInt(evenResult) + parseInt(even.charAt(r - 1)));
            }
            result = (parseInt(odd) + parseInt(evenResult));
            result = result.toString();
            result = (10 - parseInt(result.charAt(result.length - 1)));
            result = result.toString();
            if (result.length > 1) {
                result = result.charAt(result.length - 1);
            }
            if (parseInt(result) != checkDigit) {
                isId = false;
            } else {
                isId = true;
            }
        }

        if (!isId) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please enter a valid ID number.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else if (telMobile == '' || this.state.sfJourneyId == 0 || this.state.address1.trim() == '' || this.state.address2.trim() == '' || this.state.address3.trim() == '' || this.state.fname.trim() == '' || this.state.lname.trim() == '') {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please ensure all fields are completed.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else if (currDate == selectedDate) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please enter a valid Date of Birth.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else if (this.state.townId == 0) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please select a valid town.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else {

            let requestObject = this.state;

            //event.target.className += " was-validated";
            var dl = new DataLayer();
            let result = await dl.Post('/common/AddRecruit', requestObject);
            if (result.errorOccurred) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;{result.errorMessage}</span>, {
                    closeButton: false
                });
                this.setState({ btnDisabled: false })
            } else {
                this.setState({
                    modalOpen: !this.state.modalOpen,
                    msg: result.otherInfo
                });

            }
        }
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    async componentWillMount() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;

        var dl = new DataLayer();
        let result = await dl.Get('/common/getProvincesAndTowns', 200);
        let journeys = await dl.Get('/common/getJourneys', 200);
        this.setState({
            provinces: result.data.provinceList,
            towns: result.data.townList,
            provinceId: result.data.provinceList[0].value,
            townId: result.data.townList[0].value,
            DOB: today,
            townBtnHidden: result.data.provinceList[0].value == 10 ? true : false,
            journeys: journeys.data
        })
        this.props.loaderOff();
    };

    render() {
        return (
            <div>
                <Header headerText='New Recruit'
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <form
                            className="needs-validation"
                        >

                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBSelect label="Select Province"
                                        options={this.state.provinces}
                                        selected="Province"
                                        getValue={this.handleSelectChange}
                                        required
                                        search="true"
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <span>Town: {this.state.selectedTown}&nbsp;
                                        <MDBBtn hidden={this.state.townBtnHidden} tag="a" size="sm" floating onClick={this.toggleTown}>
                                            <MDBIcon icon="edit" />
                                        </MDBBtn>
                                    </span>
                                   
                                    {/*<MDBSelect label="Select Town"
                                options={this.state.towns}
                                selected="Town"
                                getValue={this.handleTownSelectChange}
                                required
                            />*/}
                                </MDBCol>
                            </MDBRow>
                            <div style={{paddingTop:'15px'}}></div>
                            <MDBRow>
                                <MDBCol md="6">
                                    <span style={{fontSize:'12px', fontWeight:'bold'}}>* Why do you want to join Tupperware</span>
                                    <MDBSelect label="Select Journey"
                                        options={this.state.journeys}
                                        selected="Journey"
                                        getValue={this.handleTownSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.title}
                                        name="title"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtTitle"
                                        label="Title"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>

                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.fname}
                                        name="fname"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="materialFormRegisterNameEx"
                                        label="First name"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.lname}
                                        name="lname"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="materialFormRegisterEmailEx2"
                                        label="Surname"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.preferredName}
                                        name="preferredName"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtPreferredName"
                                        label="Preferred Name"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.initials}
                                        name="initials"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtInitials"
                                        label="Initials"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.idNumber}
                                        name="idNumber"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtIDNumber"
                                        label="ID Number"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.emailAddress}
                                        name="emailAddress"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="emailAddress"
                                        label="Email Address"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>

                                <MDBCol md="6">
                                    <div class="block">

                                        <MDBDatePicker fromat="YYYY-MM-DD"
                                            invalidLabel=""
                                            invalidDateMessage="Please select a date"
                                            style={{ paddingTop: "15px" }}
                                            emptyLabel=""
                                            value="null" label="Date Of Birth"
                                            id="DOB" getValue={(e) => this.setState({ DOB: e })} />
                                    </div>

                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.telHome}
                                        name="telHome"
                                        onChange={this.changeHandler}
                                        type="number"
                                        id="telHome"
                                        label="Tel Home"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        
                                        name="telMobile"
                                        onChange={this.changeHandler}
                                        type="number"
                                        id="numTelMobile"
                                        label="Tel Mobile"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.address1}
                                        name="address1"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="address1"
                                        label="Address 1"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.address2}
                                        name="address2"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="address2"
                                        label="Address 2"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.address3}
                                        name="address3"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="address3"
                                        label="Address 3"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.postCode}
                                        name="postCode"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="postCode"
                                        label="Post Code"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>


                            <MDBBtn disabled={this.state.btnDisabled} color="success" onClick={this.disableButton}>
                                Submit Form
                    </MDBBtn>
                        </form>
                    </MDBCardBody>
                </MDBCard>
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />

                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Success</MDBModalHeader>
                    <MDBModalBody>
                        { this.state.msg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggle}>Continue</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            <MDBModal isOpen={this.state.townModalOpen} toggle={this.state.townModalOpen} centered>
                    <MDBModalHeader>Search Town</MDBModalHeader>
                    <MDBModalBody>
                        <AsyncSelect
                            value={this.state.selectedTown}
                            onChange={this.onSuburbChange}
                            placeholder="Type to Search Town"
                            loadOptions={this.loadSuburbs}
                        />
                    </MDBModalBody>
                    
                </MDBModal>

            </div>
        );
    }
}


export default Recruit;